import React from 'react';
import Item from './Sidebar/Item';
import { SIDEBAR_ITEMS } from '../config';


class Sidebar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let items = SIDEBAR_ITEMS;

        items.map(function(item, index) {
            items[index].active = (item.path == window.location.pathname);
        });

        return (
            <div className="m2sidebar__container">
                {items.map(item => <Item callback={this.props.darkmode} key={"sidebar_path_" + item.path} {...item}/>)}
            </div>
        );
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js